export default `
  query listProjectMembershipsForCurrentUser {
    listProjectMembershipsForCurrentUser {
      id
      userId
      lastLogin
      project {
        id
        name
        workflows {
          id
        }
        organisationId
        organisation {
          id
          name
          userId
          createdAt
          user {
            id
            firstname
            lastname
          }
        }
        jiraForgeData {
          projectId
        }
        goals {
          title
          description
        }
      }
    }
  }
`
